import { NextPage } from 'next';
import dynamic from 'next/dynamic';

import { Fragment, useState } from 'react';
// -------- custom component -------- //
import { Footer1 } from 'components/blocks/footer';
import { LocalSEO } from 'components/blocks/portfolio';

import NextLink from 'components/reuseable/links/NextLink';
import SEO from 'components/common/SEO';
import * as All from 'data/keywords';
import ProjectDetailsNavigation from 'components/common/ProjectDetailsNavigation';
// -------- custom hook -------- //
import useTooltip from 'hooks/useTooltip';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';

const details = {
  pageName: 'The Brighton Removals Company',
  categories: 'seo, ppc, social, web design',
  description:
    'The Brighton Removals Company is a local removals company based in Brighton, East Sussex. They have a turnover of approximately £380K. We designed and developed a new website for them, which is fully responsive and mobile-friendly. Our SEO efforts have achieved and maintained the number 1 spots in Google.',
  parentDirectories: 'seo-design-portfolio'
};

const Portfolio = All.LocalSEOArrays[0].keywords;

const contentRowClass = 'row gx-0';
const titleClass = 'display-6 mb-4';

const ProjectDetails: NextPage = () => {
  useTooltip();

  return (
    <Fragment>
      <main className="content-wrapper">
      
        <SEO
          title={`${Portfolio[0].title} - ${details.pageName}`}
          description={details.description}
          tag={details.categories}
          urlPT={``}
          urlENPT={``}
          url={`${Portfolio[0].url}/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}`}
          image={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
          // updated=""
          // published=""
          // modified=""
        />
        {/* ========== heading section ========== */}
        <section className="overflow-hidden position-relative none">
          {/* <div className="h-100vh h-md-auto color w-100"></div> */}
          <div className="container gx-0 border-0 text-center mt-n10 wrapper   text-white overflow-hidden d-flex align-items-center">
            {/* <div className=" hero-portfolio position-absolute left-0"> */}
              <img
                className="w-100"
                src={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg.jpg`}
                // srcSet={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg@2x.jpg 2x`}
                alt={`${Portfolio[1].title}`}
                style={{height: 400}}
              />
              <div></div>
            {/* </div> */}
            <div className="row mx-auto position-absolute top-0 w-full w-100">
              <div className="col-md-12 mx-auto border-0 text-center">
                <div className="post-header mx-auto border-0 text-center">
                  {/* <div className="post-category text-line text-white">Identity</div> */}

                  {/* <h1 className="fs-15 text-uppercase text-white mb-3 border-0 text-center mx-auto w-ful">- {Portfolio[0].title} -</h1> */}
                  <p className="display-4 text-capitalize border-0 text-center mx-auto w-full d-block  pt-5 mt-10">{details.pageName}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ========== details section ========== */}
        <section className="wrapper bg-light wrapper-border">
          <div className="container pt-14 pt-md-16 pb-13 pb-md-15 pe-md-10">
            <div className="row">
              <div className="col-lg-12 offset-lg-0">
                <h2 className={titleClass}>{Portfolio[3].title}</h2>

                <div className={`overflow-hidden ${contentRowClass}`}>
                  <div className="col-lg-8 text-justify order-0 pe-10">
                    {/* <h2 className="display-6 mb-4">{details.pageName}</h2> */}
                    <p>
                      <strong className="caption">{details.description}</strong>
                    </p>
                    <div className="position-relative">
                      <img
                        width={100}
                        height={100}
                        src={`/img/${All.localSEOPackages[1].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                        alt={All.localSEOPackages[1].title}
                        style={{ background: 'transparent' }}
                        // className="bg-overlay-image"
                        className="me-4"
                      />
                      <img
                        width={'100%'}
                        height={'auto'}
                        src={`/img/clients/${Portfolio[2].title.toLowerCase().replace(/ /g, '-')}.png`}
                        alt={Portfolio[2].title}
                        style={{ background: 'transparent' }}
                        className="mb-10 mw-30"
                      />
                    </div>
                    <h2>{Portfolio[2].title}</h2>
                    <p>
                      At <strong>SEOptimist</strong>, we're committed to delivering measurable results to our clients,
                      and The Brighton Removals Company is one of our success stories. They came to us with a goal: to
                      rank higher in local and organic search results and grow their business. We're proud to say that
                      we exceeded their expectations.
                    </p>
                    <p>
                      Our team of Brighton SEO experts performed a comprehensive analysis of the client's website,
                      identifying the issues that needed to be addressed to improve their search engine rankings. We
                      then developed a customized SEO strategy that included keyword research, on-page optimization,
                      local SEO, and link building.
                    </p>
                    <h2>{Portfolio[1].title}</h2>
                    <p>
                      SEOptimist <NextLink title={All.HomeList[0].title} href="/" /> focused on optimizing the client's
                      website for several relevant keywords, including "removals Brighton", "Brighton removals," and
                      "removal companies Brighton". We also implemented a local SEO strategy, including creating and
                      optimizing Google My Business and other local directory listings.
                    </p>
                    <p>
                      Due to this strategy, The Brighton Removal Company has 2 search results per page: 1&nbsp;local
                      result, and 1 organic result - doubling their exposure.
                    </p>
                    <h2>{Portfolio[3].title}</h2>
                    <p>
                      Our {Portfolio[3].title} team also developed high-quality content that was relevant to the
                      client's target audience and optimized it for search engines.
                    </p>
                    <p>
                      Through our efforts, The Brighton Removals Company achieved the number one spot in local and
                      organic search results for several relevant keywords. As a result, they experienced significant
                      growth, with an increase in website traffic of almost 300%. They've also purchased two more vans
                      since starting SEO with us, demonstrating the significant impact our SEO strategies had on their
                      business.
                    </p>
                    <p>
                      At SEOptimist <NextLink title={All.HomeList[0].title} href="/" />, we're committed to delivering
                      customized SEO solutions that meet our clients' unique needs. We're proud to have helped The
                      Brighton Removals Company achieve their business goals and exceed their expectations. Contact
                      SEOptimist <NextLink title={All.HomeList[1].title} href="/#contact" /> today to learn more about our
                      Brighton SEO services and how we can help your business achieve success online.
                    </p>{' '}
                    <NextLink title="Contact" href="/#contact" className="more hover" />
                  </div>

                  <div className="col-lg-4 ms-auto order-1 pt-10">
                    <img
                      width={325}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[0].title}
                      style={{ background: 'transparent' }}
                      className="mb-10"
                    />
                    <h5 className="mb-1 text-initial ps-1">
                      <u>Local Google results</u>
                    </h5>

                    <table className="table table-striped table-hover table-5">
                      <thead>
                        <tr className="border-0">
                          <th scope="col">Keyword</th>
                          <th scope="col" style={{ minWidth: 71 }}>
                            Position{''}
                            {/* <figure
                              style={{ float: 'right' }}
                              className="itooltip itooltip-light hover-scale rounded"
                              title={'Google position in local results'}
                            >
                              <i className="uil uil-info-circle"></i>
                            </figure> */}
                          </th>

                          <th scope="col" className="border-0 text-end" style={{ minWidth: 93 }}>
                            Traffic
                            {/* <figure
                              style={{ float: 'right' }}
                              className="itooltip itooltip-light hover-scale rounded"
                              title={'Google position in local results'}
                            >
                              <i className="uil uil-info-circle"></i>
                            </figure> */}
                          </th>
                        </tr>
                      </thead>
                       
                      <tbody>
                            <tr className="border-0">
                              <td className="border-0">removals brighton</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">720</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">removal companies brighton</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">720</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">removals brighton</td>
                              <td className="border-0 text-center">2</td>
                              <td className="border-0 text-end">720</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">removal companies brighton and hove</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">480</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">removal companies brighton and hove</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">480</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">brighton removals</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">210</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">brighton removals company</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">170</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">removal companies with storage</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">170</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">brighton removals company</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">170</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">removals in brighton</td>
                              <td className="border-0 text-center">2</td>
                              <td className="border-0 text-end">170</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">removal van brighton</td>
                              <td className="border-0 text-center">5</td>
                              <td className="border-0 text-end">170</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">brighton movers</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">140</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">brighton moving company</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">140</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">best removal company near me</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">140</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">removal company brighton hove</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">110</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">removal firms brighton</td>
                              <td className="border-0 text-center">3</td>
                              <td className="border-0 text-end">110</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">removal company brighton hove</td>
                              <td className="border-0 text-center">1</td>
                              <td className="border-0 text-end">110</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">moving services brighton</td>
                              <td className="border-0 text-center">2</td>
                              <td className="border-0 text-end">110</td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">removal firms brighton</td>
                              <td className="border-0 text-center">6</td>
                              <td className="border-0 text-end">110</td>
                            </tr> 
                          </tbody> 
                      <tfoot>
                        <tr className="border-0">
                          <td colSpan={2}>
                            <strong>Total</strong>
                          </td> 
                          <td className="border-0 text-end">
                            <strong>5,150+</strong>

                          </td>
                        </tr>
                        <tr><td style={{paddingTop:20}} colSpan={3}>
                        <sup>National and Europe results are not included in the local total.</sup></td></tr>
                      </tfoot>
                    </table>
                    <ul className="list-unstyled">
                      <li>
                        <h5 className="mb-1 ps-1">Categories</h5>
                        <p className="ps-1">{details.categories}</p>
                      </li>
                      <li>
                        <h5 className="mb-1 ps-1">Client Name</h5>
                        <p className="ps-1">{details.pageName}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <LocalSEO initialslide={1} />
          </div>
        </section>

        <ProjectDetailsNavigation />
      </main>

      <ContactFooterCombo location="brighton" />
    </Fragment>
  );
};

export default ProjectDetails;
